import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './layouts/private-layout/private-layout.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EmployeeListComponent } from './employees/employee-list.component';
import { EmployeeProfileComponent } from './employees/employee-profile/employee-profile.component';
import { AddEmployeeComponent } from './employees/add-employee/add-employee.component';
import { EditEmployeeComponent } from './employees/edit-employee/edit-employee.component';
import { authGuard } from './auth/auth.guard';
import { roleGuard, hrAdminGuard, managerGuard } from './auth/role.guard';

export const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: LandingPageComponent }, // or landing
      {
        path: 'login',
        loadComponent: () =>
          import('./auth/login/login.component').then((m) => m.LoginComponent),
      }
    ]
  },
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'employees',
        component: EmployeeListComponent,
        canActivate: [roleGuard],
        data: { permissions: ['VIEW_ALL_EMPLOYEES'] }
      },
      {
        path: 'employees/add',
        component: AddEmployeeComponent,
        canActivate: [hrAdminGuard]
      },
      {
        path: 'employees/:id/edit',
        component: EditEmployeeComponent,
        canActivate: [roleGuard],
        data: { permissions: ['EDIT_ALL_EMPLOYEES', 'EDIT_OWN_PROFILE'] }
      },
      {
        path: 'employees/:id/profile',
        component: EmployeeProfileComponent,
        canActivate: [roleGuard],
        data: { permissions: ['VIEW_ALL_EMPLOYEES', 'VIEW_OWN_PROFILE'] }
      },
      {
        path: 'rota-planner',
        loadChildren: () => import('./rota-planner/rota-planner.routes').then(m => m.ROTA_PLANNER_ROUTES),
        canActivate: [authGuard],
        data: {
          title: 'Rota Planner',
          breadcrumb: 'Rota Planner'
        }
      },
      {
        path: 'timesheet',
        loadChildren: () =>
          import('./timesheet/timesheet.module').then((m) => m.TimesheetModule),
        canActivate: [authGuard],
        data: {
          title: 'Timesheet Management',
          breadcrumb: 'Timesheet'
        }
      },
      {
        path: 'leave',
        loadChildren: () =>
          import('./leave/leave.module').then((m) => m.LeaveModule),
        canActivate: [authGuard],
        data: {
          title: 'Leave Management',
          breadcrumb: 'Leave'
        }
      },
      {
        path: 'performance',
        loadChildren: () =>
          import('./performance/performance.module').then((m) => m.PerformanceModule),
        canActivate: [authGuard],
        data: {
          title: 'Performance Management',
          breadcrumb: 'Performance'
        }
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./documents/documents.module').then((m) => m.DocumentsModule),
        canActivate: [authGuard],
        data: {
          title: 'Document Management',
          breadcrumb: 'Documents'
        }
      }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
